/**
 * Enum containing the keys used for invalidating react query
 */
export enum QueryKeys {
  Company = 'company',
  Companies = 'companies',
  CompanyAdmins = 'companyAdmins',
  LeaveSchedule = 'leaveSchedule',
  LeaveHolidays = 'leaveHolidays',
  EmployeeLeaveBalances = 'employeeLeaveBalances',
  EmployeeImportJobs = 'employeeImportJobs',
  EmployeeImportJobDetails = 'employeeImportDetails',
  EmployeeLeaveRequests = 'EmployeeLeaveRequests',
  LeaveTypes = 'leaveTypes',
  Employees = 'employees',
  LeaveSettings = 'leaveSettings',
  LeaveCalendar = 'leaveCalendar',
}
